import { Confirmation as OASConfirmation } from '@/features/book-appointment/confirmation';

export default OASConfirmation;
